module.exports = __webpack_public_path__ + "static/cei-084882adc2a76c3d0c9666bf703192d1.png";